import { lazyLoad } from 'controller/utils/loadable';

export const ExpenseReceiptPrint = lazyLoad(
    () => import('./index'),
    module => module.default,
);
